import { render } from "./ShopItems.vue?vue&type=template&id=4ad69c52&ts=true"
import script from "./ShopItems.vue?vue&type=script&lang=ts"
export * from "./ShopItems.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__